import { render, staticRenderFns } from "./layout_header.vue?vue&type=template&id=655f12ac&scoped=true&"
import script from "./layout_header.vue?vue&type=script&lang=js&"
export * from "./layout_header.vue?vue&type=script&lang=js&"
import style0 from "./layout_header.vue?vue&type=style&index=0&id=655f12ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f12ac",
  null
  
)

export default component.exports